import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import ApplicationCard from '../applications/ApplicationCard';
import BasicLayout from '../BasicLayout';
import { globalStyles as styles } from '../style/gstheme';

class AccountApplications extends React.Component {

  render() {

    const { user } = this.props;

    const isAdmin = user.systemAdmin || user.superAdmin;

    return (
      <BasicLayout title="Account">
        <Grid role="main" data-test="application-choices" spacing={2} container justifyContent="space-evenly" classes={
          {
            "spacing-xs-2": this.props.classes.fullGrid
          }
        }>
          {!isAdmin &&
            <Grid item>
              <ApplicationCard
                dataTest="subscriptions-card"
                id="subscriptions"
                url="/account/subscriptions"
                title="Subscriptions"
                description="Create and manage subscriptions."
                thumbnail="/images/subscriptions.svg"
              />
            </Grid>
          }
          <Grid item>
            <ApplicationCard
              dataTest="mydetails-card"
              id="mydetails"
              url="/account/mydetails"
              title="My Details"
              description="Create and manage your account details."
              thumbnail="/images/mydetails.svg"
            />
          </Grid>
        </Grid>
      </BasicLayout>
    );
  }
}

AccountApplications.propTypes = {
  classes: PropTypes.object,
  user: PropTypes.object
};

export default withStyles(styles)(AccountApplications);